import { PackageTypes } from "enum/package-types.enum";
import { Meta } from "interfaces/api.interface";
import { DimensionUnits } from "interfaces/dimension-units.type";
import { WeightUnits } from "interfaces/weight-units.type";
import { IShipmentPackageGrouped } from "models/shipmentPackage/shipmentPackage.model";
import {
  convertKilosToGrams,
  convertValueToDatabase,
} from "utils/convertGramsToKilos";

export const MAX_PARCEL_METRIC_WEIGHT_GRAMS = convertValueToDatabase(
  convertKilosToGrams(70)
);

export const MAX_PACKAGE_HEIGHT_CM = convertValueToDatabase(270);

export const MAX_PACKAGE_GIRTH_CM = convertValueToDatabase(440);

export const MAX_ENVELOPPE_WEIGHT_GRAMS = convertValueToDatabase(
  convertKilosToGrams(0.5)
);

export const MAX_TOTAL_WEIGHT_BEFORE_FREIGHT_WARNING = convertValueToDatabase(
  convertKilosToGrams(150)
);

export const DEFAULT_PAGE_SIZE = 50;

export const DEFAULT_DIMENSIONS_UNIT = DimensionUnits.cm;

export const DEFAULT_WEIGHT_UNIT = WeightUnits.kg;

export const DEFAULT_MIN_HEIGHT_CM = convertValueToDatabase(0.1);

export const DEFAULT_MIN_WIDTH_CM = convertValueToDatabase(0.1);

export const DEFAULT_MIN_LENGTH_CM = convertValueToDatabase(0.1);

export const DEFAULT_MIN_WEIGHT_GRAMS = convertValueToDatabase(0.1);

export const DEFAULT_CURRENCY_ISO = "GBP";

export const DEFAULT_FROM_COUNTRY = "United Kingdom";

export const DEFAULT_FROM_COUNTRY_ISO_CODE = "GB";

export const GA_DEFAULT_FROM_COUNTRY_ISO_CODE = "US";

export const DEFAULT_PACKAGE_TYPE = PackageTypes.Parcel;

export const IRELAND_ISO_CODE = "IE";

export const DEFAULT_META: Meta = {
  recordCount: 0,
  limit: DEFAULT_PAGE_SIZE,
  offset: 0,
  pageCount: 0,
};

export const DEFAULT_PACKAGE: IShipmentPackageGrouped = {
  weight: 0,
  quantity: 1,
  width: 0,
  type: DEFAULT_PACKAGE_TYPE,
  length: 0,
  height: 0,
  lithiumCategory: "",
  dryIceWeight: 0,
  dgunNumber: 0,
  class: "",
  packingGroup: "",
  dgNetWeight: 0,
  dgPackage: false,
  dgVolumeMl100: 0,
};

export const ZIP_VALIDATION_WHITELIST = ["IE", "HK", "LB"];

export const FREIGHT_TEAM_EMAIL_ADDRESS = "freightquote@itdglobal.com";

export const SUPPORTED_COUNTRIES = [
    "AF",
    "AL",
    "DZ",
    "AS",
    "AD",
    "AO",
    "AI",
    "AG",
    "AR",
    "AM",
    "AW",
    "AU",
    "AT",
    "AZ",
    "BS",
    "BH",
    "BD",
    "BB",
    "BY",
    "BE",
    "BZ",
    "BJ",
    "BM",
    "BT",
    "BO",
    "BQ",
    "BA",
    "BW",
    "BR",
    "IO",
    "VG",
    "BN",
    "BG",
    "BF",
    "BI",
    "KH",
    "CM",
    "CA",
    "CV",
    "KY",
    "CF",
    "TD",
    "CL",
    "CN",
    "CX",
    "CC",
    "CO",
    "KM",
    "CK",
    "CR",
    "CI",
    "HR",
    "CU",
    "CW",
    "CY",
    "CZ",
    "CD",
    "DK",
    "DJ",
    "DM",
    "DO",
    "EC",
    "EG",
    "SV",
    "GQ",
    "ER",
    "EE",
    "SZ",
    "ET",
    "FK",
    "FO",
    "FM",
    "FJ",
    "FI",
    "FR",
    "GF",
    "PF",
    "GA",
    "GM",
    "GE",
    "DE",
    "GH",
    "GI",
    "GR",
    "GL",
    "GD",
    "GP",
    "GU",
    "GT",
    "GN",
    "GW",
    "GY",
    "HT",
    "HN",
    "HK",
    "HU",
    "IS",
    "IN",
    "ID",
    "IR",
    "IQ",
    "IE",
    "IL",
    "IT",
    "JM",
    "JP",
    "JO",
    "KZ",
    "KE",
    "KI",
    "XK",
    "KW",
    "KG",
    "LA",
    "LV",
    "LB",
    "LS",
    "LR",
    "LY",
    "LI",
    "LT",
    "LU",
    "MO",
    "MG",
    "MW",
    "MY",
    "MV",
    "ML",
    "MT",
    "MH",
    "MQ",
    "MR",
    "MU",
    "YT",
    "MX",
    "MD",
    "MC",
    "MN",
    "ME",
    "MS",
    "MA",
    "MZ",
    "MM",
    "NA",
    "NR",
    "NP",
    "NL",
    "NC",
    "NZ",
    "NI",
    "NE",
    "NG",
    "NU",
    "NF",
    "KP",
    "MK",
    "MP",
    "NO",
    "OM",
    "PK",
    "PW",
    "PA",
    "PG",
    "PY",
    "PE",
    "PH",
    "PN",
    "PL",
    "PT",
    "PR",
    "QA",
    "CG",
    "RE",
    "RO",
    "RU",
    "RW",
    "BL",
    "SH",
    "KN",
    "LC",
    "MF",
    "PM",
    "VC",
    "WS",
    "SM",
    "ST",
    "SA",
    "SN",
    "RS",
    "SC",
    "SL",
    "SG",
    "SX",
    "SK",
    "SI",
    "SB",
    "SO",
    "ZA",
    "GS",
    "KR",
    "SS",
    "ES",
    "LK",
    "SD",
    "SR",
    "SJ",
    "SE",
    "CH",
    "SY",
    "TW",
    "TJ",
    "TZ",
    "TH",
    "TL",
    "TG",
    "TK",
    "TO",
    "TT",
    "TN",
    "TR",
    "TM",
    "TC",
    "TV",
    "UG",
    "UA",
    "AE",
    "GB",
    "US",
    "VI",
    "UY",
    "UZ",
    "VU",
    "VA",
    "VE",
    "VN",
    "WF",
    "EH",
    "YE",
    "ZM",
    "ZW",
  ];
